import Layout from "./components/Layout";
import Chat from "../Tools/Chat";
import SignUpForm from "../Account/components/SignUpForm";
import useTargetUrl from "./utils/useTargetUrl";
import { useParams } from "react-router-dom";

export default function Signin(){

    const { id } = useParams()

    const targetUrl = useTargetUrl()

    return (
        <Layout center>

            <SignUpForm 
                successUrl={targetUrl}
                signInUrl={`/courses/${id}/signin`}
            />

            <Chat />

        </Layout>
    );
}